import DataRoomIsLockedUserCard from './DataRoomIsLockedUserCard.component';

export default DataRoomIsLockedUserCard;
